import VueRouter from 'vue-router';
import App from '@/app';
import Landing from '@/components/landing';
import NotFound from '@/components/not-found';
import AccessToken from '@/components/access-token';
import routesRecording from './routes-recording';
import routesWebinar from './routes-webinar';
import routesEmbedded from './routes-embedded';

const routes = [
  {
    path: '/',
    component: App,
    children: [
      {
        path: '',
        name: 'landing',
        component: Landing
      },
      {
        // auth service redirects to <redirect_uri>/#access_token=xxx...
        // so this route is taken
        path: 'access_token*',
        name: 'accessToken',
        component: AccessToken
      },
      routesRecording,
      routesWebinar,
      routesEmbedded,
      {
        path: '*',
        name: 'not-found',
        component: NotFound
      }
    ]
  },
  {
    // identical to registration link
    path: 'register/:webinarKey',
    redirect: { name: 'registration' }
  },
  {
    // identical to join link, but attend directly instead of triggering join flow
    path: 'join/:webinarKey/:registrantKey',
    redirect: { name: 'attendance' }
  }
];

export default new VueRouter({routes});
